<template>
  <div class="card" :class="{'-has-error': errors.cantFetchChartData}">
    <div class="header">
      <div class="description">
        <h2 class="title">
          Tipos mais utilizados
          <span class="errorMessage" v-if="errors.cantFetchChartData">Erro</span>
        </h2>
      </div>
    </div>

    <div class="body">
      <pie-chart-skeleton-loader
        :quantity-series="4"
        v-if="loading"
      />
      <apex-chart
        type="donut"
        height="350"
        :options="chartOptions"
        :series="chartSeries"
        v-else
      ></apex-chart>
    </div>
  </div>
</template>

<script>
import ApexChart from 'vue-apexcharts';
import PieChartSkeletonLoader from '@/support/components/loader/PieChartSkeletonLoader.vue';
import { shuffle } from 'lodash';

export default {
  name: 'TypesMostUsedPieChart',

  props: {
    period: {
      required: true,
      type: Number,
    },
  },

  data() {
    return {
      loading: false,
      chartSeries: [],
      chartOptionsLabels: [],
      errors: {
        cantFetchChartData: false,
      },
    };
  },

  methods: {
    /**
     * Fetch the chart data.
     *
     * @returns {Promise<void>}
     */
    async fetchChartData() {
      try {
        this.resetErrors();
        this.resetChartData();
        this.loading = true;

        const { data } = await this.$http.get(`metrics/charts/types-most-used?period=${this.period}`);

        this.chartSeries = [...data.series];
        this.chartOptionsLabels = [...data.labels];
      } catch {
        this.errors.cantFetchChartData = true;
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Ocorreu um erro',
          text: 'Não foi possível carregar os tipos mais utilizadas.',
        });
      } finally {
        this.loading = false;
      }
    },

    /**
     * Reset the errors to initial values.
     */
    resetErrors() {
      this.errors.cantFetchChartData = false;
    },

    /**
     * Reset chart data.
     */
    resetChartData() {
      this.chartSeries = [];
      this.chartOptionsLabels = [];
    },
  },

  computed: {
    chartOptions() {
      return {
        chart: {
          height: window.screen.availHeight > 768 ? 350 : 300,
          toolbar: {
            show: false,
          },
        },
        colors: shuffle(['#7366ff', '#f73164', '#ecc94b', '#49BC78', '#4299e1']),
        labels: this.chartOptionsLabels,
      };
    },
  },

  watch: {
    period() {
      this.fetchChartData();
    },
  },

  mounted() {
    this.fetchChartData();
  },

  components: {
    ApexChart,
    PieChartSkeletonLoader,
  },
};
</script>

<style lang="scss" scoped>

</style>
